import { LoginService, LoginServiceImpl } from '@/services/loginService'
import { http } from '@/repositories/http'
import { UpdatePasswordService, UpdatePasswordServiceImpl } from '@/services/updatePasswordService'
import { TenantService, TenantServiceImpl } from '@/services/tenantService'
import { FuzokuMeisaiService, FuzokuMeisaiServiceImpl } from '@/services/fuzokuMeisaiService'
import { ClearCacheService, ClearCacheServiceImpl } from '@/services/clearCacheService'
import { DeliverySlipService, DeliverySlipServiceImpl } from '@/services/deliverySlipService'

type Services = {
  login: LoginService,
  updatePassword: UpdatePasswordService;
  tenant: TenantService;
  fuzoku: FuzokuMeisaiService;
  clearCache: ClearCacheService;
  deliverySlip: DeliverySlipService;
}

export const services: Services = {
  login: new LoginServiceImpl(http),
  updatePassword: new UpdatePasswordServiceImpl(http),
  tenant: new TenantServiceImpl(http),
  fuzoku: new FuzokuMeisaiServiceImpl(http),
  clearCache: new ClearCacheServiceImpl(http),
  deliverySlip: new DeliverySlipServiceImpl(http)
}
